import { createStore } from 'vuex'
import { UserInfo, store as userStore } from './modules/user'

export interface RootState {
    user: UserInfo
}

export default createStore<RootState>({
    getters: {
    },

    mutations: {
    },

    actions: {
    },

    modules: {
        userStore,
    }
})
